import React from "react";
import GitHubCalendar from "react-github-calendar";
class GithubStats extends React.Component {
  render() {
    return (
      <div>
        <div
          style={{ margin: "1% 15% 3% 15%" }}
          className="react-activity-calendar"
        >
          {/* Include your GitHub activity calendar component here */}
          <GitHubCalendar
            username="PrabhatAcharya"
            blockSize={15}
            blockMargin={5}
            // theme={colourTheme}
            fontSize={16}
          />
        </div>
        <div style={{ display: "flex", margin: "1% 6% 3% 6%", gap: "2%" }}>
          <img
            id="github-streak-stats"
            src="https://github-readme-streak-stats.herokuapp.com/?user=PrabhatAcharya&theme=chartreuse-dark"
          />
          <img
            id="github-top-langs"
            src="https://github-readme-stats.vercel.app/api/top-langs?username=PrabhatAcharya&show_icons=true&locale=en&layout=compact&theme=chartreuse-dark"
          />

          <img
            id="github-stats-card"
            src="https://github-readme-stats.vercel.app/api?username=PrabhatAcharya&show_icons=true&locale=en&theme=chartreuse-dark"
          />
        </div>
      </div>
    );
  }
}

export default GithubStats;
